// extracted by mini-css-extract-plugin
export default {"header":"TopSelling_header__8ZN1-","items":"TopSelling_items__yF1kM","view-all-button":"TopSelling_view-all-button__h9dzL","button-container":"TopSelling_button-container__A7ORV"};